import { Link } from "react-router-dom";
import { Gauge, ArrowRight } from "@phosphor-icons/react";
import { useUsageSummary } from "../hooks/useUsageSummary";
import { formatTokens, formatUsd } from "../lib/format";

export function UsageMiniCard() {
  const summary = useUsageSummary("30d");
  if (!summary.data || summary.data.totals.callCount === 0) return null;

  const { costUsd, totalTokens, callCount } = summary.data.totals;

  return (
    <Link
      to="/uso"
      className="group flex items-center gap-3 rounded-lg border border-white/[0.06] bg-card/50 hover:bg-card hover:border-white/[0.12] px-3 py-2 transition-colors text-xs"
      aria-label="Ver detalhes de uso e custos"
    >
      <Gauge weight="duotone" className="h-4 w-4 text-primary" aria-hidden="true" />
      <span className="text-muted-foreground">Últimos 30 dias:</span>
      <span
        className="font-medium text-foreground tabular-nums"
        style={{ fontVariantNumeric: "tabular-nums" }}
      >
        {formatUsd(costUsd)}
      </span>
      <span className="text-muted-foreground hidden sm:inline">
        · {formatTokens(totalTokens)} tokens · {callCount} calls
      </span>
      <ArrowRight
        weight="regular"
        className="h-3.5 w-3.5 text-muted-foreground ml-auto group-hover:text-foreground transition-colors"
        aria-hidden="true"
      />
    </Link>
  );
}
